import React from 'react'
import { useTranslation } from 'react-i18next'
import { linkPrimary, qrCodeSecondary, scanQuartiary } from '../../images'

interface CardData {
  links: number
  qrCodes: number
}

interface CardProps {
  data: CardData
  dateRange: string
  total: number
}

const CardStatistics = ({ data, dateRange, total }: CardProps) => {
  const { t } = useTranslation()

  return (
    <>
      <div className='container-statitics'>
        <span className='title py-4 text-initial bolder'>{`${t(
          'STATISTICS'
        )}`}</span>
        <span className='title py-4 text-initial bolder'>{dateRange}</span>

        <div className='container-statitics-content'>
          <img
            height={30}
            src={scanQuartiary}
            alt={`${t('INTERACTIONS_TOTAL')}`}
          />
          <span className='mx-4 max-title color-grey'>{total}</span>
          <span className='title'>{`${t('INTERACTIONS_TOTAL')}`}</span>
        </div>
        <div className='container-statitics-content'>
          <img
            height={25}
            width={25}
            src={linkPrimary}
            alt={`${t('CREATED_LINKS')}`}
          />
          <span className='mx-4 max-title color-primary'>{data.links}</span>
          <span className='title'>{`${t('CREATED_LINKS')}`}</span>
        </div>
        <div className='container-statitics-content'>
          <img
            height={25}
            src={qrCodeSecondary}
            alt={`${t('CREATED_QR_CODES')}`}
          />
          <span className='mx-4 max-title color-secondary'>{data.qrCodes}</span>
          <span className='title'>{`${t('CREATED_QR_CODES')}`}</span>
        </div>
      </div>
    </>
  )
}

export default CardStatistics
